import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromTaxIdentificationNumberDetails from '../../reducers/tax-identification-number-details/tax-identification-number-details.reducer';

export const selectTaxIdentificationNumberDetailsState = createFeatureSelector<fromTaxIdentificationNumberDetails.State>(
  fromTaxIdentificationNumberDetails.taxIdentificationNumberDetailsFeatureKey
);



export const selectTINInfo = createSelector(
    selectTaxIdentificationNumberDetailsState,
    (state: fromTaxIdentificationNumberDetails.State) => ({
      // data: state.contactDetails,
      itemsPerPage: state.itemsPerPage,
      itemsPerPageList: [5,10, 25,100],
      totalItems: state.totalItems,
      // page: state.page,
    })
)

// Can't async pipe  data need this selector
export const selectTINDetailsData = createSelector(
    selectTaxIdentificationNumberDetailsState,
    (state: fromTaxIdentificationNumberDetails.State) => state.tins
)

export const selectIsSaveDisabled = createSelector(
    selectTaxIdentificationNumberDetailsState,
    (state: fromTaxIdentificationNumberDetails.State) => {
        return state.isSaveDisabled;
    }
)
